<template>
</template>


<script>

export default {
    beforeCreate: function () {
        const params = this.$route.query;
        const wechatCode = params.code
        const code = params.c
        if (wechatCode == null || wechatCode == undefined) {
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbc22565b3e7a59fd&redirect_uri=' + window.location.href + '&response_type=code&scope=snsapi_base&state=tcpanda_auth#wechat_redirect';
        }else
        {
            window.location.href = 'https://www.t3j.top/suisen?c='+code+'&code='+wechatCode+'&state=tcpanda_auth';
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SuiSen/Load.vue